import {
	ROUTE_COMMISSION_REPORT
} from 'constants/RouterNames'

const commissionReportPage = () => import('components/pages/secured/financial/commissionReport/commissionReport')

const commissionReport = {
	path: '/relatorio-contabil',
	component: commissionReportPage,
	meta: {
		breadcrumb: { name: 'Comissão por Período' },
		requiresAuthorities: ROUTE_COMMISSION_REPORT.routerAuth
	},
	name: ROUTE_COMMISSION_REPORT.name
}

export default commissionReport
